/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Intro_P1_AfterInputs */

const es_l6_intro_p1_after = /** @type {(inputs: L6_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, sin escalados ni cuotas sorpresa.`)
};

const gl_l6_intro_p1_after = /** @type {(inputs: L6_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, sen escalados nin cotas sorpresa.`)
};

const en_l6_intro_p1_after = /** @type {(inputs: L6_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, with no tiers or surprise fees.`)
};

/**
* | output |
* | --- |
* | ", with no tiers or surprise fees." |
*
* @param {L6_Intro_P1_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_intro_p1_after = /** @type {((inputs?: L6_Intro_P1_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Intro_P1_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_intro_p1_after(inputs)
	if (locale === "en") return en_l6_intro_p1_after(inputs)
	return es_l6_intro_p1_after(inputs)
});